import c from "./ghl-ui.es1488.js";
var n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, s = /\\(\\)?/g, u = c(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(n, function(a, t, o, p) {
    r.push(o ? p.replace(s, "$1") : t || a);
  }), r;
});
const i = u;
export {
  i as default
};
